export enum BUSINESS_TYPE {
    OFFLINE = 'OFFLINE',
    ONLINE = 'ONLINE'
}